@if (comments() && comments()?.length) {
  <section>
    <label class="section-label">
      {{ 'page.simplified_shift_drawer.client_comments' | translate }}
    </label>
    @for (comment of comments(); track comment.id) {
      <wilson-shift-client-comment
        [shiftComment]="comment"
        (commentChange)="
          updateClientComment({ id: comment.id, comment: $event })
        "
      ></wilson-shift-client-comment>
    }
  </section>
}
